import React, { useEffect, useState } from "react";
import { FaRegSave } from "react-icons/fa";
import { toast } from "sonner";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
import { addLookup, fetchLookups } from "../../services/product";

const Lookup = ({ asin }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [lookups, setLookups] = useState([]);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const getLookups = async () => {
    const response = await fetchLookups(asin);
    setLookups(response);
  };

  useEffect(() => {
    getLookups();
  }, [asin]);

  const lookUpSearch = (event) => {
    event.preventDefault();
    const source = searchTerm;
    const addLookupFunction = async () => {
      const response = await addLookup({ asin, source });
      if (response?.success) {
        toast.success("Lookup added successfully");
        getLookups();
      }
    };

    addLookupFunction();
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "numeric", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options);
  }

  return (
    <div className="flex flex-col w-full text-white">
      <div
        className="flex cursor-pointer items-center mb-2 justify-between"
        onClick={toggleAccordion}
      >
        <div className="mr-1 text-primary text-md font-bold">
          Lookup Details
        </div>
        <div className="text-primary">
          {isOpen ? (
            <MdExpandMore className="w-6 h-6" />
          ) : (
            <MdExpandLess className="w-6 h-6" />
          )}
        </div>
      </div>
      {isOpen && (
        <div className="rounded-lg">
          <form onSubmit={lookUpSearch}>
             <p className="text-white text-left text-sm mb-1">Source</p>
            <div className="flex gap-2 items-center mb-2">
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="URL, Store, etc."
                  className="text-white text-sm bg-secondary-bg border border-gray-700 rounded-lg px-3 py-2 outline-none focus:ring-0 focus:border-primary placeholder-white md:w-1/3 w-full"
                />
              <button
                type="button"
                onClick={lookUpSearch}
                className="bg-secondary p-2 rounded-lg"
              >
                <FaRegSave className="text-white cursor-pointer w-5 h-5" />
              </button>
            </div>
          </form>
          {/* Additional content can go here */}
          <div className="">
            {lookups?.length > 0 && (
              <table className="w-full mt-2">
                <thead>
                  <tr className="text-xs font-semibold">
                    <div className="flex">
                      <div className="p-1 flex-2"></div>
                      <div className="p-1 flex-1">History</div>
                      <div className="p-1 flex-1">Source</div>
                      <div className="p-1 flex-1">Cost</div>
                      <div className="p-1 flex-1">Sale</div>
                    </div>
                  </tr>
                </thead>
                <tbody>
                  {lookups?.map((property, index) => (
                    <tr key={index}>
                      <td className="p-0">
                        <div
                          className="text-center text-sm text-white bg-secondary-bg p-4 rounded-lg"
                          style={{
                            marginBottom: "2px",
                            marginTop: index === 0 ? "0" : "4px",
                            padding: "6px 2px 6px 6px",
                          }}
                        >
                          <div className="flex items-center justify-around text-left">
                            {/* <div className="p-1 pl-0 pr-2 flex-2">{index + 1}</div> */}
                            <div className="p-1 flex-1">
                              {formatDate(property?.createdAt) || "-"}
                            </div>
                            <div className="p-1 flex-1 capitalize">
                              {property?.source || "Not Specified"}
                            </div>
                            <div className="p-1 flex-1">
                              $
                              {
                                property?.data?.profitCalculator?.prices
                                  ?.cost_price
                              }
                            </div>
                            <div className="p-1 flex-1">
                              $
                              {
                                property?.data?.profitCalculator?.prices
                                  ?.sale_price
                              }
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Lookup;
